import { Story } from '@/hooks/useStories';

interface StoryCardProps {
  story: Story;
  onClick: () => void;
}

export const StoryCard = ({ story, onClick }: StoryCardProps) => {
  return (
    <div
      onClick={onClick}
      className="flex-shrink-0 cursor-pointer group"
    >
      {/* Full-size story card with glass effect */}
      <div className="w-72 h-48 relative rounded-xl overflow-hidden shadow-lg border border-border/20 hover:border-primary/40 transition-all duration-300 group-hover:shadow-2xl">
        
        {/* Animated gradient border */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-primary/80 via-accent/60 to-primary/80 opacity-0 group-hover:opacity-100 transition-all duration-500 p-[2px]">
          <div className="w-full h-full bg-card rounded-xl"></div>
        </div>
        
        {/* Media content */}
        <div className="relative w-full h-full rounded-xl overflow-hidden">
        {story.media_type === 'video' ? (
            <video
              src={story.media_url}
              poster={story.thumbnail_url}
              className="w-full h-full object-cover transition-transform duration-300"
              muted
            />
          ) : (
            <img
              src={story.media_url}
              alt={story.alt_text || story.title || 'Story'}
              className="w-full h-full object-cover transition-transform duration-300"
              loading="lazy"
              decoding="async"
            />
          )}
          
          {/* Glass effect overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
          
          {/* Title at bottom */}
          {story.title && (
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <h3 className="text-foreground text-sm font-semibold font-mono truncate drop-shadow-lg">{story.title}</h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};